import { useEffect } from "react";
import * as React from "react";
import { PlaceholderSidebar } from "./Sidebar";
import { usePlaceholderPopupStore } from "@/state/placeholderPopupStore";
import ContentLibrary from "./components/ContentLibrary";
import AlphaPopup from "./components/AlphaPopup";

const PlaceholderContainer: React.FC = () => {
  const { sidebar, handleReopenWithFlag } = usePlaceholderPopupStore();
  const { selectedContent, showSidebar } = usePlaceholderPopupStore();

  // Auto-handle state when reopening with fromPlaceholderPopup flag
  useEffect(() => {
    handleReopenWithFlag();
  }, [handleReopenWithFlag]);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        gap: "1rem",
        minHeight: "100vh",
      }}
    >
      {showSidebar && <PlaceholderSidebar />}
      <div style={{ width: showSidebar ? "78%" : "100%", marginLeft: showSidebar ? "auto" : 0 }}>
        {selectedContent === "line" ? <AlphaPopup /> : sidebar === "share-price-performance" && <ContentLibrary />}
      </div>
    </div>
  );
};

export default PlaceholderContainer;


